// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Ui__Box from "../box/Ui__Box.bs.js";
import * as ExpoImage from "expo-image";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as Core__Option from "@rescript/core/src/Core__Option.bs.js";
import * as ReactNative from "react-native";
import * as Style$ReactNative from "rescript-react-native/src/apis/Style.bs.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Utils__SimpleReact from "@pageblocks/utils/src/simpleReact/Utils__SimpleReact.bs.js";

function Ui__BoxWithImageBackground(props) {
  var children = props.children;
  var source = props.source;
  var onProgress = props.onProgress;
  var onLoadStart = props.onLoadStart;
  var onLoadEnd = props.onLoadEnd;
  var onLoad = props.onLoad;
  var onError = props.onError;
  var focusable = props.focusable;
  var enableLiveTextInteraction = props.enableLiveTextInteraction;
  var recyclingKey = props.recyclingKey;
  var responsivePolicy = props.responsivePolicy;
  var cachePolicy = props.cachePolicy;
  var priority = props.priority;
  var tintColor = props.tintColor;
  var contentPosition = props.contentPosition;
  var transition = props.transition;
  var placeholderContentFit = props.placeholderContentFit;
  var contentFit = props.contentFit;
  var placeHolderSource = props.placeHolderSource;
  var blurRadius = props.blurRadius;
  var imageStyle = props.imageStyle;
  var accessibilityLabel = props.accessibilityLabel;
  var __accessibilityIgnoresInvertColors = props.accessibilityIgnoresInvertColors;
  var accessible = props.accessible;
  var style = props.style;
  var __kind = props.kind;
  var imageTestID = props.imageTestID;
  var kind = __kind !== undefined ? __kind : "NonPressable";
  var accessibilityIgnoresInvertColors = __accessibilityIgnoresInvertColors !== undefined ? __accessibilityIgnoresInvertColors : true;
  return JsxRuntime.jsx(Ui__Box.make, {
              kind: kind,
              onHover: props.onHover,
              children: (function (interactionState) {
                  var style$1 = Core__Option.map(style, (function (makeStyle) {
                          return makeStyle(interactionState);
                        }));
                  var match;
                  if (style$1 !== undefined) {
                    var style$2 = Caml_option.valFromOption(style$1);
                    match = [
                      style$2["width"],
                      style$2["height"]
                    ];
                  } else {
                    match = [
                      undefined,
                      undefined
                    ];
                  }
                  var height = match[1];
                  var width = match[0];
                  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
                              children: [
                                Utils__SimpleReact.renderIfSome(source, (function (source) {
                                        return JsxRuntime.jsx(ExpoImage.Image, {
                                                    source: source,
                                                    placeholder: placeHolderSource,
                                                    contentFit: contentFit,
                                                    contentPosition: contentPosition,
                                                    placeholderContentFit: placeholderContentFit,
                                                    transition: transition,
                                                    blurRadius: blurRadius,
                                                    tintColor: tintColor,
                                                    priority: priority,
                                                    cachePolicy: cachePolicy,
                                                    responsivePolicy: responsivePolicy,
                                                    recyclingKey: recyclingKey,
                                                    onLoadStart: onLoadStart,
                                                    onLoad: onLoad,
                                                    onProgress: onProgress,
                                                    onError: onError,
                                                    onLoadEnd: onLoadEnd,
                                                    focusable: focusable,
                                                    accessible: accessible,
                                                    accessibilityLabel: accessibilityLabel,
                                                    enableLiveTextInteraction: enableLiveTextInteraction,
                                                    style: [
                                                      Caml_option.some(ReactNative.StyleSheet.absoluteFillObject),
                                                      {
                                                        height: Core__Option.getOr(Core__Option.map(height, (function (prim) {
                                                                    return prim;
                                                                  })), Style$ReactNative.pct(100)),
                                                        width: Core__Option.getOr(Core__Option.map(width, (function (prim) {
                                                                    return prim;
                                                                  })), Style$ReactNative.pct(100)),
                                                        zIndex: -1
                                                      },
                                                      Core__Option.map(imageStyle, (function (makeImageStyle) {
                                                              return makeImageStyle(interactionState);
                                                            }))
                                                    ],
                                                    testID: imageTestID
                                                  });
                                      })),
                                Core__Option.getOr(Core__Option.map(children, (function (children) {
                                            return children(interactionState);
                                          })), null)
                              ]
                            });
                }),
              style: style,
              onLayout: props.onLayout,
              hitSlop: props.hitSlop,
              testID: props.testID,
              importantForAccessibility: props.importantForAccessibility,
              accessible: accessible,
              accessibilityElementsHidden: props.accessibilityElementsHidden,
              accessibilityHint: props.accessibilityHint,
              accessibilityIgnoresInvertColors: accessibilityIgnoresInvertColors,
              accessibilityLabel: accessibilityLabel,
              accessibilityLiveRegion: props.accessibilityLiveRegion,
              accessibilityRole: props.accessibilityRole,
              accessibilityState: props.accessibilityState,
              accessibilityValue: props.accessibilityValue,
              accessibilityViewIsModal: props.accessibilityViewIsModal,
              updateChildProps: props.updateChildProps
            });
}

var make = Ui__BoxWithImageBackground;

export {
  make ,
}
/* Ui__Box Not a pure module */
